import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import IntradayML from './pages/IntradayML';

const LandingPage = lazy(() => import('./pages/LandingPage'));
const MultiStrategySignals = lazy(() => import('./pages/MultiStrategySignals'));
const FundamentalSignals = lazy(() => import('./pages/FundamentalSignals'));
const SwingStrategies = lazy(() => import('./pages/SwingStrategies'));
const Blog = lazy(() => import('./pages/Blog'));
const Account = lazy(() => import('./pages/Account'));
const Terms = lazy(() => import('./pages/Terms'));
const Privacy = lazy(() => import('./pages/Privacy'));

const isProd = import.meta.env.VITE_MODE === 'prod';

function App() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={isProd ? <Navigate to="/ml-trading" replace /> : <LandingPage />} />
        <Route path="/ml-trading" element={<IntradayML />} />
        <Route path="/intraday" element={<Navigate to="/ml-trading" replace />} />
        <Route path="/account" element={<Account />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        {!isProd && (
          <>
            <Route path="/multi-strategy-signals" element={<MultiStrategySignals />} />
            <Route path="/fundamental-signals" element={<FundamentalSignals />} />
            <Route path="/swing" element={<SwingStrategies />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<Blog />} />
          </>
        )}
      </Routes>
    </Suspense>
  );
}

export default App;
